import React, { useRef, useState } from "react";
import styled from "styled-components";


const ArticlePartnerCredit = ({ article }) => {
  return (
      <StyledArticlePartnerCredit>
        <p>Originally published in partnership with&nbsp;
        {article.canonical_syndication.url ? (
          <a href={article.canonical_syndication.url} title={`Read in ${article.canonical_syndication.outlet.name}`} target="_blank" rel="noopener noreferrer">{article.canonical_syndication.outlet.name}</a>
        ) : (
          <>{article.canonical_syndication.outlet.name}</>
        )}.</p>
      </StyledArticlePartnerCredit>
  );
};

export default ArticlePartnerCredit;


const StyledArticlePartnerCredit = styled.aside`
  position: relative;
  padding: 2em 0 0;
  margin: 0 auto;
  max-width: var(--text-max-width);
    text-align: center;
  p {
    font-size: 1.125em;
    font-family: var(--font-serif);
    font-style: italic;
    a {
      text-decoration-line: underline;
      text-decoration-thickness: 0.75px;
      text-underline-offset: 0.1em;
      text-decoration-color: var(--theme-text-against-dark-medium);
      .can-hover &:hover,
      &:active {
        opacity: 0.5;
      }
    }
  }
  /*
  @media ( min-width: 70em ) {
    float: right;
    width: calc(((100% - var(--text-max-width)) / 2) - 2em);
    text-align: left;
    margin-top: 3.125em;
    padding: 0 0 0 1em;
    &::before {

    }
    border-left: 1px solid var(--theme-border-against-dark);
    p {
      margin: 0;
    }
  }
  */
`;
